import { Grid, Box } from '@mui/material'
import React from 'react'
import { ListItemNoIcon } from '../ListItemNoIcon'
import { PickingRoute } from '../../../interfaces/Picking/Picking'
import { dateToString } from '../helpers'

interface PickingRouteHeaderProps {
  pickingRoute?: PickingRoute
}

export const PickingRouteHeader: React.FC<PickingRouteHeaderProps> = ({
  pickingRoute
}) => {
  const route: PickingRoute = pickingRoute ? pickingRoute : new PickingRoute()
  const avance = `${route.pickedProducts}/${route.countProducts}`
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <ListItemNoIcon
            primary={`Inicio ruta (${route.pickingRouteId})`}
            secondary={dateToString(route.startedAt)}
          />
        </Grid>
        <Grid item xs={4}>
          <ListItemNoIcon primary='Avance' secondary={avance} />
        </Grid>
      </Grid>
    </Box>
  )
}
